  const carSwiper = new Swiper('#carSwiper', {
    slidesPerView: 2.5,
    spaceBetween:24,
    loop: true,
    autoplay: {
  delay: 3000,
},
disableOnInteraction: false,
pauseOnMouseEnter: true,

    navigation: {
      prevEl: '#carPrev',
      nextEl: '#carNext',
    },
    breakpoints: {
      0:   { slidesPerView: 1.6, spaceBetween: 14, freeMode: {
        enabled: true,
      } },
      769: { slidesPerView: 2.5, spaceBetween: 14,},
      1025: { slidesPerView: 2.5,spaceBetween: 24 },
      1921: { slidesPerView: 3.5, spaceBetween: 24 },
    }
  });
 
  const reviewSwiper = new Swiper('#reviewSwiper', {
    slidesPerView: 1.8,
    spaceBetween: 24,
    loop: true,
     autoplay: {
  delay: 5000,
},
disableOnInteraction: false,
pauseOnMouseEnter: true,
    navigation: {
      prevEl: '#reviewPrev',
      nextEl: '#reviewNext',
    },
    breakpoints: {
      0:   { slidesPerView: 1.3, spaceBetween: 14, freeMode: {
        enabled: true,
      },},
      769: { slidesPerView: 1.2,  spaceBetween: 14 },
      1025: { slidesPerView: 1.8,    spaceBetween: 24 },

      }
  });

  
/* ------------------------------
    Loading
------------------------------ */

const isContactPosted =
  new URLSearchParams(window.location.search).get('contact_posted') === 'true';

const isSelectModel =
  window.location.hash === '#select-model';

if (isContactPosted || isSelectModel) {

    document.querySelector('.loading')?.remove();
    document.querySelector('#wrapper')?.classList.remove('is-fview');
    document.querySelector('.mv')?.classList.add('is-show');

    document.querySelectorAll('.vid').forEach(video => {
        video.play();
    });

} else {

    setTimeout(() => {
        document.querySelector('.loading').classList.add('is-show');
    }, 500);

    setTimeout(() => {
        document.querySelector('#wrapper').classList.remove('is-fview');

        document.querySelector('.mv')?.classList.add('is-show');

        setTimeout(() => {
            document.querySelectorAll('.vid').forEach(video => {
                video.play();
            });
        }, 300);

    }, 5900);

}